import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { PhoneCall, Clock, Globe, Calendar, HelpCircle, ArrowUpRight, MessageSquare } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: AI Voice Agents — Calls Handled Automatically | MindStream.ing
  Meta Desc: MISTR's voice agents take calls, answer questions, schedule appointments, and escalate when needed — automatically, in any language, around the clock.
  Primary KW: AI voice agent for business
*/
export function VoiceAgents() {
  return <FeaturePageLayout seoTitle="AI Voice Agents — Calls Handled Automatically | MindStream.ing" seoDesc="MISTR's voice agents take calls, answer questions, schedule appointments, and escalate when needed — automatically, in any language, around the clock." heroEyebrow="VOICE AGENTS" heroTitle={<>
          Voice Agents That <span className="text-gradient" data-id="element-2894" data-mp="3jzw9nijkuyxf">Never Sleep.</span>
        </>} heroDesc="MR's voice takes calls, answers questions, schedules appointments, and escalates when needed — automatically, in any language, around the clock." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'Call Comes In',
      desc: "Inbound calls route directly to MR's voice interface."
    }, {
      title: 'MR Handles',
      desc: 'MR handles intake, answers questions, and books appointments.'
    }, {
      title: 'Smart Escalate',
      desc: 'Only complex or high-value calls are escalated to a human.'
    }]
  }} features={{
    cards: [{
      icon: <MessageSquare size={24} data-id="element-2895" data-mp="1tq3dz7ir7h63" />,
      title: '24/7 Availability',
      desc: 'Never miss a call again. MR is always awake and ready to help.'
    }, {
      icon: <PhoneCall size={24} data-id="element-2896" data-mp="312caz14blk4r" />,
      title: 'Natural Conversation',
      desc: 'Sounds human, understands context, and handles interruptions gracefully.'
    }, {
      icon: <Globe size={24} data-id="element-2897" data-mp="3arvso3gar7y1" />,
      title: 'Any Language',
      desc: 'Speaks and understands multiple languages, switching seamlessly mid-conversation.'
    }, {
      icon: <Calendar size={24} data-id="element-2898" data-mp="2i5b2v7fgz3wl" />,
      title: 'Appointment Booking',
      desc: 'Checks your calendar and schedules meetings directly during the call.'
    }, {
      icon: <HelpCircle size={24} data-id="element-2899" data-mp="2r5zejvhe4s6b" />,
      title: 'Question Answering',
      desc: 'Pulls from your ThinkTank to answer FAQs accurately and instantly.'
    }, {
      icon: <ArrowUpRight size={24} data-id="element-2900" data-mp="6dnuvql6l4z3" />,
      title: 'Smart Escalation',
      desc: 'Knows exactly when to transfer the call to you or your team.'
    }]
  }} data-id="element-2893" data-mp="1ynl4691gzkxr" />;
}